<script setup lang="ts">
import '@/assets/styles/navbar.css';
</script>

<template>
  <header class="navbar">
    <div class="navbar-header">
      <img class="logo" src="/logo.png" alt="Firmenlogo"/>
      <div class="brand-copy">
        <span class="brand-demo">Musterwebsite</span>
        <h1>KFZ Musterwerkstatt</h1>
      </div>
    </div>

    <nav class="stones" aria-label="Hauptnavigation">
      <router-link to="/" class="stones-link">Home</router-link>
      <router-link to="/about" class="stones-link">Über uns</router-link>
      <router-link to="/services" class="stones-link">Leistungen</router-link>
      <router-link to="/products" class="stones-link">Produkte</router-link>
      <router-link to="/career" class="stones-link">Karriere</router-link>
      <router-link to="/contact" class="stones-link">Kontakt</router-link>
    </nav>
  </header>
</template>

<style scoped>
</style>
